module.exports = __webpack_public_path__ + "static/adminconfig-dbc22c878ec1328d9a71cfb66a60d983.png";